const semanticClassNames = {
  root: 'breadcrumbs',
  item: 'breadcrumbs__item',
};

export default semanticClassNames;
